import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative space-y-6 lg:space-y-8 px-3 sm:px-4 lg:px-8 min-h-[calc(100vh-8rem)] pt-6" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "bg-red-50 text-red-600 p-4 rounded-xl border border-red-200"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200/50 dark:border-slate-700/50 overflow-hidden"
}
const _hoisted_5 = { class: "hidden lg:block overflow-x-auto" }
const _hoisted_6 = { class: "min-w-full divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_7 = { class: "divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "px-6 py-4 text-center text-sm font-medium text-slate-700 dark:text-slate-300" }
const _hoisted_10 = { class: "px-6 py-4 text-center text-sm text-slate-500 dark:text-slate-400" }
const _hoisted_11 = { class: "px-6 py-4 text-center" }
const _hoisted_12 = { class: "px-6 py-4" }
const _hoisted_13 = { class: "flex gap-2 justify-center" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "lg:hidden divide-y divide-slate-200/50 dark:divide-slate-700/50" }
const _hoisted_20 = {
  key: 0,
  class: "p-8 flex justify-center"
}
const _hoisted_21 = {
  key: 1,
  class: "px-6 py-12 text-center text-slate-500"
}
const _hoisted_22 = { class: "text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" }
const _hoisted_23 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_24 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_25 = { class: "flex gap-2" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 2,
  class: "card border border-gray-200/50 dark:border-gray-700/50 shadow-sm sticky bottom-0 z-30"
}
const _hoisted_32 = { class: "p-4" }
const _hoisted_33 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_34 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-lg sm:w-full flex flex-col" }
const _hoisted_35 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6 flex items-center justify-between flex-shrink-0" }
const _hoisted_36 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto flex-1 max-h-[calc(100vh-12rem)]" }
const _hoisted_37 = { class: "space-y-4" }
const _hoisted_38 = { class: "flex items-center gap-4 w-full" }
const _hoisted_39 = { class: "h-11 w-11 rounded-xl flex items-center justify-center bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200" }
const _hoisted_40 = { class: "min-w-0 flex-1 overflow-hidden" }
const _hoisted_41 = ["title"]
const _hoisted_42 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_43 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0 shrink-0" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "text-sm text-secondary-text/80 dark:text-secondary-dark-text/80" }
const _hoisted_46 = { class: "font-semibold text-slate-700 dark:text-slate-300" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "flex sm:items-center sm:justify-center min-h-screen sm:px-4 sm:pt-4 sm:pb-20 text-center" }
const _hoisted_49 = { class: "inline-block align-bottom sm:align-middle bg-white dark:bg-gray-800 sm:rounded-lg text-left overflow-hidden shadow-xl transform transition-all min-h-screen w-full fixed inset-x-0 top-0 sm:static sm:min-h-0 sm:max-w-lg sm:w-full flex flex-col" }
const _hoisted_50 = { class: "bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 px-4 py-4 sm:px-6 flex items-center justify-between flex-shrink-0" }
const _hoisted_51 = { class: "bg-white dark:bg-gray-800 px-3 pt-4 pb-3 sm:p-6 sm:pb-4 overflow-y-auto flex-1 max-h-[calc(100vh-12rem)]" }
const _hoisted_52 = { class: "space-y-4" }
const _hoisted_53 = { class: "flex items-center gap-4 w-full" }
const _hoisted_54 = { class: "h-11 w-11 rounded-xl flex items-center justify-center bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-200" }
const _hoisted_55 = { class: "min-w-0 flex-1 overflow-hidden" }
const _hoisted_56 = ["title"]
const _hoisted_57 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_58 = { class: "bg-gray-50 dark:bg-gray-700 px-4 py-3 flex flex-col gap-2 sm:px-6 sm:flex-row-reverse sm:gap-0 shrink-0" }
const _hoisted_59 = ["disabled"]

import { ref, computed, onMounted, watch } from 'vue'
import UploadIcon from '@/components/icons/UploadIcon.vue'
import { FilePlusCorner, Eye, Trash, Download as DownloadIcon, Printer, Pencil, Loader2, X } from 'lucide-vue-next'
import { employeeDocumentService, type EmployeeDocument } from '@/services/employeeDocumentService'
import Modal from '@/components/layout/Modal.vue'
import DocumentDetailsModal from '@/components/documents/DocumentDetailsModal.vue'
import TableControls from '@/components/layout/TableControls.vue'
import PaginationBar from '@/components/layout/PaginationBar.vue'
import TableLoader from '@/components/ui/TableLoader.vue'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeDocumentsView',
  setup(__props) {

const toast = useToast()
const documents = ref<EmployeeDocument[]>([])
const loading = ref(false)
const error = ref('')

const searchQuery = ref('')
const statusFilter = ref('')
const perPage = ref(10)
const currentPage = ref(1)

const showUploadModal = ref(false)
const uploadTitle = ref('')
const uploadFile = ref<File | null>(null)
const uploadError = ref('')
const uploading = ref(false)
const uploadFileInput = ref<HTMLInputElement | null>(null)
const uploadDragOver = ref(false)

const searchFiltered = computed(() => {
  if (!searchQuery.value.trim()) return documents.value
  const q = searchQuery.value.toLowerCase()
  return documents.value.filter(d => (d.title || '').toLowerCase().includes(q))
})

const filteredTotal = computed(() => searchFiltered.value.length)
const filteredTotalPages = computed(() => Math.max(1, Math.ceil(searchFiltered.value.length / perPage.value)))

const paginatedDocuments = computed(() => {
  const start = (currentPage.value - 1) * perPage.value
  return searchFiltered.value.slice(start, start + perPage.value)
})

watch([searchQuery, statusFilter, perPage], () => {
  currentPage.value = 1
})

const goToPage = (page: number) => {
  currentPage.value = page
}

const fetchDocuments = async () => {
  loading.value = true
  error.value = ''
  try {
    documents.value = await employeeDocumentService.fetchAll()
  } catch (err: any) {
    error.value = 'Failed to load your documents.'
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchDocuments()
})

const openUploadFilePicker = () => uploadFileInput.value?.click()

const onUploadFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  const file = target.files?.[0] ?? null
  if (file) uploadFile.value = file
}

const onUploadDrop = (e: DragEvent) => {
  uploadDragOver.value = false
  const file = e.dataTransfer?.files?.[0] ?? null
  if (file) uploadFile.value = file
}

const uploadDocument = async () => {
  uploadError.value = ''
  if (!uploadTitle.value.trim()) {
    uploadError.value = 'Title is required.'
    return
  }
  if (!uploadFile.value) {
    uploadError.value = 'Please select a file.'
    return
  }

  const formData = new FormData()
  formData.append('title', uploadTitle.value.trim())
  formData.append('file', uploadFile.value)

  uploading.value = true
  try {
    await employeeDocumentService.create(formData)
    toast.success('Document uploaded successfully', { timeout: toastTimeout })
    showUploadModal.value = false
    uploadTitle.value = ''
    uploadFile.value = null
    fetchDocuments()
  } catch (err: any) {
    uploadError.value = err.response?.data?.message || 'Failed to upload document.'
  } finally {
    uploading.value = false
  }
}

const showDeleteModal = ref(false)
const deleteLoading = ref(false)
const pendingDeleteId = ref<number | null>(null)
const pendingDeleteTitle = ref('')

const showViewModal = ref(false)
const selectedDocument = ref<EmployeeDocument | null>(null)
const showEditModal = ref(false)
const editTitle = ref('')
const editFile = ref<File | null>(null)
const editError = ref('')
const editLoading = ref(false)
const editingDocId = ref<number | null>(null)
const editFileInput = ref<HTMLInputElement | null>(null)
const editDragOver = ref(false)

const viewDocument = (doc: EmployeeDocument) => {
  selectedDocument.value = doc
  showViewModal.value = true
}

const downloadDocument = async (doc: EmployeeDocument) => {
  const loadingToast = toast.info('Preparing document for download...', { timeout: false })
  try {
    const token = localStorage.getItem('token')
    const url = employeeDocumentService.getDownloadUrl(doc.id)
    const response = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    if (!response.ok) throw new Error('Invalid File')
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = doc.title || 'download'
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(blobUrl)
    document.body.removeChild(a)
    toast.dismiss(loadingToast)
    toast.success('Document downloaded successfully', { timeout: toastTimeout })
  } catch {
    toast.dismiss(loadingToast)
    toast.error('Failed to download document', { timeout: toastTimeout })
  }
}

const printDocument = async (doc: EmployeeDocument) => {
  const loadingToast = toast.info('Preparing document for printing...', { timeout: false })
  try {
    await employeeDocumentService.printDocument(doc.id)
    toast.dismiss(loadingToast)
  } catch (err: any) {
    toast.dismiss(loadingToast)
    if (!err.message?.includes('opened in a new tab')) {
      toast.error(err.message || 'Failed to print document', { timeout: toastTimeout })
    }
  }
}

const handleDelete = (doc: EmployeeDocument) => {
  pendingDeleteId.value = doc.id
  pendingDeleteTitle.value = doc.title || 'this document'
  showDeleteModal.value = true
}

const confirmDelete = async () => {
  if (pendingDeleteId.value === null) return
  deleteLoading.value = true
  try {
    await employeeDocumentService.delete(pendingDeleteId.value)
    toast.success('Document deleted', { timeout: toastTimeout })
    showDeleteModal.value = false
    pendingDeleteId.value = null
    fetchDocuments()
  } catch {
    toast.error('Failed to delete document', { timeout: toastTimeout })
  } finally {
    deleteLoading.value = false
  }
}

const openEditFilePicker = () => editFileInput.value?.click()

const onEditDrop = (e: DragEvent) => {
  editDragOver.value = false
  const file = e.dataTransfer?.files?.[0] ?? null
  if (file) editFile.value = file
}

const openEditModal = (doc: EmployeeDocument) => {
  editingDocId.value = doc.id
  editTitle.value = doc.title
  editFile.value = null
  editError.value = ''
  showEditModal.value = true
}

const onEditFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  editFile.value = target.files?.[0] || null
}

const confirmEdit = async () => {
  if (!editingDocId.value) return
  if (!editTitle.value.trim()) {
    editError.value = 'Title is required.'
    return
  }
  const formData = new FormData()
  formData.append('title', editTitle.value.trim())
  if (editFile.value) {
    formData.append('file', editFile.value)
  }
  editLoading.value = true
  editError.value = ''
  try {
    await employeeDocumentService.update(editingDocId.value, formData)
    toast.success('Document updated successfully', { timeout: toastTimeout })
    showEditModal.value = false
    fetchDocuments()
  } catch (err: unknown) {
    const axiosErr = err as { response?: { data?: { message?: string } } }
    editError.value = axiosErr.response?.data?.message || 'Failed to update document.'
  } finally {
    editLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[22] || (_cache[22] = _createElementVNode("div", null, [
        _createElementVNode("h1", { class: "text-2xl sm:text-3xl lg:text-4xl font-bold text-primary dark:text-secondary" }, " My Documents "),
        _createElementVNode("p", { class: "text-sm text-slate-500 dark:text-slate-200 mt-2" }, " Upload and manage your important documents. ")
      ], -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showUploadModal.value = true)),
        class: "px-6 py-2 rounded-lg font-semibold text-white transition bg-primary hover:bg-secondary shadow-md hover:opacity-90 flex items-center justify-center w-full sm:w-auto"
      }, [
        _createVNode(_unref(FilePlusCorner), { class: "h-5 w-5 mr-2" }),
        _cache[21] || (_cache[21] = _createTextVNode(" Upload Document ", -1))
      ])
    ]),
    _createVNode(TableControls, {
      search: searchQuery.value,
      "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
      status: statusFilter.value,
      "onUpdate:status": _cache[2] || (_cache[2] = ($event: any) => ((statusFilter).value = $event)),
      perPage: perPage.value,
      "onUpdate:perPage": _cache[3] || (_cache[3] = ($event: any) => ((perPage).value = $event)),
      placeholder: "Search by title...",
      options: [{ value: '', label: 'All' }],
      filterLabel: "Filter",
      class: "md:sticky md:top-[80px]"
    }, null, 8, ["search", "status", "perPage"]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(error.value), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("table", _hoisted_6, [
              _cache[24] || (_cache[24] = _createElementVNode("thead", { class: "bg-slate-50 dark:bg-slate-800/50" }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Title"),
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Uploaded At"),
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Status"),
                  _createElementVNode("th", { class: "px-6 py-4 text-center text-xs font-bold text-slate-700 dark:text-slate-300 uppercase" }, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_7, [
                (loading.value)
                  ? (_openBlock(), _createBlock(TableLoader, {
                      key: 0,
                      colspan: 4,
                      title: "Fetching Documents"
                    }))
                  : (paginatedDocuments.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("td", {
                          colspan: "4",
                          class: "px-6 py-12 text-center text-slate-500"
                        }, " You haven't uploaded any documents yet. ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedDocuments.value, (doc) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: doc.id,
                    class: "hover:bg-slate-50 dark:hover:bg-slate-800/50 transition"
                  }, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(doc.title), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(new Date(doc.created_at).toLocaleString()), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-3 py-1 text-xs font-semibold rounded-full", doc.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-600'])
                      }, _toDisplayString(doc.status), 3)
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewDocument(doc)),
                          class: "p-2 text-blue-600 hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5" })
                        ], 8, _hoisted_14),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (downloadDocument(doc)),
                          class: "p-2 text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Download"
                        }, [
                          _createVNode(_unref(DownloadIcon), { class: "w-5 h-5" })
                        ], 8, _hoisted_15),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printDocument(doc)),
                          class: "p-2 text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_16),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openEditModal(doc)),
                          class: "p-2 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20 rounded-lg transition-colors",
                          title: "Edit"
                        }, [
                          _createVNode(_unref(Pencil), { class: "w-5 h-5" })
                        ], 8, _hoisted_17),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (handleDelete(doc)),
                          class: "p-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors",
                          title: "Delete"
                        }, [
                          _createVNode(_unref(Trash), { class: "w-5 h-5" })
                        ], 8, _hoisted_18)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_unref(Loader2), { class: "w-8 h-8 animate-spin text-primary" })
                ]))
              : (paginatedDocuments.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "You haven't uploaded any documents yet."))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(paginatedDocuments.value, (doc) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: doc.id,
                      class: "p-4 hover:bg-slate-50 dark:hover:bg-slate-800/50"
                    }, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(doc.title), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 py-1 text-xs font-semibold rounded-full", doc.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-600'])
                        }, _toDisplayString(doc.status), 3),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(new Date(doc.created_at).toLocaleString()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (viewDocument(doc)),
                          class: "p-2 text-blue-600 hover:bg-primary/10 rounded-lg transition-colors",
                          title: "View"
                        }, [
                          _createVNode(_unref(Eye), { class: "w-5 h-5" })
                        ], 8, _hoisted_26),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (downloadDocument(doc)),
                          class: "p-2 text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors",
                          title: "Download"
                        }, [
                          _createVNode(_unref(DownloadIcon), { class: "w-5 h-5" })
                        ], 8, _hoisted_27),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (printDocument(doc)),
                          class: "p-2 text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20 rounded-lg transition-colors",
                          title: "Print"
                        }, [
                          _createVNode(_unref(Printer), { class: "w-5 h-5" })
                        ], 8, _hoisted_28),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openEditModal(doc)),
                          class: "p-2 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20 rounded-lg transition-colors",
                          title: "Edit"
                        }, [
                          _createVNode(_unref(Pencil), { class: "w-5 h-5" })
                        ], 8, _hoisted_29),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (handleDelete(doc)),
                          class: "p-2 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors",
                          title: "Delete"
                        }, [
                          _createVNode(_unref(Trash), { class: "w-5 h-5" })
                        ], 8, _hoisted_30)
                      ])
                    ]))
                  }), 128))
          ])
        ])),
    (!loading.value && !error.value && filteredTotal.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(PaginationBar, {
              "current-page": currentPage.value,
              "total-pages": filteredTotalPages.value,
              total: filteredTotal.value,
              "per-page": perPage.value,
              "onUpdate:page": goToPage
            }, null, 8, ["current-page", "total-pages", "total", "per-page"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showUploadModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (showUploadModal.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_33, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50" }, null, -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-bold text-white truncate" }, "Upload Document", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showUploadModal.value = false)),
                      class: "shrink-0 p-1.5 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
                    }, [
                      _createVNode(_unref(X), { class: "h-5 w-5" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-sm font-medium text-slate-700 dark:text-slate-200" }, [
                          _createTextVNode("Document Title "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((uploadTitle).value = $event)),
                          type: "text",
                          class: "mt-1 w-full rounded-xl border px-3 py-2 bg-white dark:bg-slate-900",
                          placeholder: "e.g. CPR Certification"
                        }, null, 512), [
                          [_vModelText, uploadTitle.value]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", { class: "text-sm font-medium text-slate-700 dark:text-slate-200" }, [
                          _createTextVNode("File "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mt-1 rounded-2xl border-2 border-dashed p-6 cursor-pointer select-none bg-white/60 dark:bg-gray-800/50 border-gray-300/70 dark:border-gray-600/60 hover:bg-white/80 dark:hover:bg-gray-800/70", uploadDragOver.value ? 'ring-2 ring-primary/50 border-primary/60' : '']),
                          onClick: openUploadFilePicker,
                          onDragenter: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (uploadDragOver.value = true), ["prevent"])),
                          onDragover: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (uploadDragOver.value = true), ["prevent"])),
                          onDragleave: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (uploadDragOver.value = false), ["prevent"])),
                          onDrop: _withModifiers(onUploadDrop, ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(UploadIcon)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              (uploadFile.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("p", {
                                      class: "text-sm font-semibold text-gray-800 dark:text-gray-100 truncate",
                                      title: uploadFile.value.name
                                    }, _toDisplayString(uploadFile.value.name), 9, _hoisted_41),
                                    _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Click or drop to change file", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-800 dark:text-gray-100" }, "Drag & drop your file here", -1)),
                                    _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "or click to browse", -1))
                                  ], 64))
                            ])
                          ])
                        ], 34),
                        _createElementVNode("input", {
                          ref_key: "uploadFileInput",
                          ref: uploadFileInput,
                          type: "file",
                          class: "hidden",
                          accept: "*/*",
                          onChange: onUploadFileChange
                        }, null, 544)
                      ]),
                      (uploadError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(uploadError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto sm:ml-3 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-secondary shadow-sm transition-all disabled:opacity-60",
                      disabled: uploading.value,
                      onClick: uploadDocument
                    }, _toDisplayString(uploading.value ? 'Uploading...' : 'Upload'), 9, _hoisted_44),
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (showUploadModal.value = false))
                    }, "Cancel")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(Modal, {
      modelValue: showDeleteModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((showDeleteModal).value = $event)),
      title: "Delete Document"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-secondary-text dark:text-secondary-dark-text hover:bg-gray-100/80 dark:hover:bg-gray-700/60 transition-colors duration-200",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (showDeleteModal.value = false))
        }, "Cancel"),
        _createElementVNode("button", {
          type: "button",
          class: "ml-2 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-danger hover:bg-danger/90 shadow-sm hover:shadow-md transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed",
          disabled: deleteLoading.value,
          onClick: confirmDelete
        }, _toDisplayString(deleteLoading.value ? 'Deleting...' : 'Yes, delete permanently'), 9, _hoisted_47)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_45, [
          _cache[32] || (_cache[32] = _createTextVNode(" Are you sure you want to permanently delete ", -1)),
          _createElementVNode("span", _hoisted_46, "\"" + _toDisplayString(pendingDeleteTitle.value) + "\"", 1),
          _cache[33] || (_cache[33] = _createTextVNode("? This action cannot be undone. ", -1))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showEditModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (showEditModal.value = false), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_48, [
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-black bg-opacity-50 dark:bg-opacity-50" }, null, -1)),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _cache[34] || (_cache[34] = _createElementVNode("h3", { class: "text-lg font-bold text-white truncate" }, "Edit Document", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (showEditModal.value = false)),
                      class: "shrink-0 p-1.5 rounded-lg hover:bg-white/10 text-white/80 hover:text-white transition-colors"
                    }, [
                      _createVNode(_unref(X), { class: "h-5 w-5" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", null, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", { class: "text-sm font-medium text-slate-700 dark:text-slate-200" }, [
                          _createTextVNode("Document Title "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editTitle).value = $event)),
                          type: "text",
                          class: "mt-1 w-full rounded-xl border px-3 py-2 bg-white dark:bg-slate-900",
                          placeholder: "e.g. CPR Certification"
                        }, null, 512), [
                          [_vModelText, editTitle.value]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-sm font-medium text-slate-700 dark:text-slate-200" }, "File (leave empty to keep current)", -1)),
                        _createElementVNode("div", {
                          class: _normalizeClass(["mt-1 rounded-2xl border-2 border-dashed p-6 cursor-pointer select-none bg-white/60 dark:bg-gray-800/50 border-gray-300/70 dark:border-gray-600/60 hover:bg-white/80 dark:hover:bg-gray-800/70", editDragOver.value ? 'ring-2 ring-primary/50 border-primary/60' : '']),
                          onClick: openEditFilePicker,
                          onDragenter: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (editDragOver.value = true), ["prevent"])),
                          onDragover: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (editDragOver.value = true), ["prevent"])),
                          onDragleave: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (editDragOver.value = false), ["prevent"])),
                          onDrop: _withModifiers(onEditDrop, ["prevent"])
                        }, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(UploadIcon)
                            ]),
                            _createElementVNode("div", _hoisted_55, [
                              (editFile.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("p", {
                                      class: "text-sm font-semibold text-gray-800 dark:text-gray-100 truncate",
                                      title: editFile.value.name
                                    }, _toDisplayString(editFile.value.name), 9, _hoisted_56),
                                    _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Click or drop to change file", -1))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _cache[37] || (_cache[37] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-800 dark:text-gray-100" }, "Drag & drop your file here", -1)),
                                    _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "or click to browse", -1))
                                  ], 64))
                            ])
                          ])
                        ], 34),
                        _createElementVNode("input", {
                          ref_key: "editFileInput",
                          ref: editFileInput,
                          type: "file",
                          class: "hidden",
                          accept: "*/*",
                          onChange: onEditFileChange
                        }, null, 544)
                      ]),
                      (editError.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_57, _toDisplayString(editError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto sm:ml-3 px-4 py-2 rounded-lg text-sm font-semibold text-white bg-primary hover:bg-secondary shadow-sm transition-all disabled:opacity-50",
                      disabled: editLoading.value,
                      onClick: confirmEdit
                    }, _toDisplayString(editLoading.value ? 'Saving...' : 'Save'), 9, _hoisted_59),
                    _createElementVNode("button", {
                      type: "button",
                      class: "w-full sm:w-auto px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium text-slate-700 dark:text-slate-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (showEditModal.value = false))
                    }, "Cancel")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(DocumentDetailsModal, {
      "is-open": showViewModal.value,
      document: selectedDocument.value,
      onClose: _cache[20] || (_cache[20] = ($event: any) => {showViewModal.value = false; selectedDocument.value = null})
    }, null, 8, ["is-open", "document"])
  ]))
}
}

})